import React from 'react';
/* import { ConnectionStatus } from './ConnectionStatus'; */
import { ProfileTable } from 'components/table/profile/ProfileTable';

const Profiles: React.FC = () => {

    /* const [isConnected, setIsConnected] = useState(false); */

    /* useWebSocket(setProfiles, setIsConnected, isConnected); */

    return (
        <>
            <ProfileTable/>
        </>
    );
};

export { Profiles };
